// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-e5870344] .el-date-editor .el-range-input {\n  box-shadow: none !important;\n}\n.el-icon-error[data-v-e5870344] {\n  right: 8px;\n  position: absolute;\n  font-size: 14px;\n  top: 50%;\n  color: #d9d9d9;\n  transform: translateY(-50%);\n}\n[data-v-e5870344] .el-range-editor--small .el-range-separator {\n  line-height: 36px;\n}\n[data-v-e5870344] .el-range-editor--small.el-input__inner {\n  line-height: 36px;\n  height: 36px;\n}\n", ""]);
// Exports
module.exports = exports;
